import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height", "viewBox", "fill"];
const _hoisted_2 = ["fill", "fill-opacity"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'CirclePlusIcon',
    props: {
        width: { default: 22 },
        height: { default: 22 },
        viewBox: { default: '0 0 22 22' },
        background: { default: 'none' },
        color: { default: 'white' },
        opacity: { default: 1 }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: _ctx.width,
                height: _ctx.height,
                viewBox: _ctx.viewBox,
                fill: _ctx.background
            }, [
                _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M11 0.5C5.20077 0.5 0.5 5.20077 0.5 11C0.5 16.7992 5.20077 21.5 11 21.5C16.7992 21.5 21.5 16.7992 21.5 11C21.5 5.20077 16.7992 0.5 11 0.5ZM11.8077 7.76923C11.8077 7.55502 11.7226 7.34958 11.5711 7.19811C11.4197 7.04663 11.2142 6.96154 11 6.96154C10.7858 6.96154 10.5803 7.04663 10.4289 7.19811C10.2774 7.34958 10.1923 7.55502 10.1923 7.76923V10.1923H7.76923C7.55502 10.1923 7.34958 10.2774 7.19811 10.4289C7.04663 10.5803 6.96154 10.7858 6.96154 11C6.96154 11.2142 7.04663 11.4197 7.19811 11.5711C7.34958 11.7226 7.55502 11.8077 7.76923 11.8077H10.1923V14.2308C10.1923 14.445 10.2774 14.6504 10.4289 14.8019C10.5803 14.9534 10.7858 15.0385 11 15.0385C11.2142 15.0385 11.4197 14.9534 11.5711 14.8019C11.7226 14.6504 11.8077 14.445 11.8077 14.2308V11.8077H14.2308C14.445 11.8077 14.6504 11.7226 14.8019 11.5711C14.9534 11.4197 15.0385 11.2142 15.0385 11C15.0385 10.7858 14.9534 10.5803 14.8019 10.4289C14.6504 10.2774 14.445 10.1923 14.2308 10.1923H11.8077V7.76923Z",
                    fill: _ctx.color,
                    "fill-opacity": _ctx.opacity
                }, null, 8, _hoisted_2)
            ], 8, _hoisted_1));
        };
    }
});
